import React from 'react';
import { css } from "react-emotion";

const container = css`
  width: 100%;
`;

const dropDownButton = css`
  cursor: pointer;
  text-align: right;
`;

class DropDown extends React.Component {
  state = {
    hidden: true
  }

  toggleDropDown = e => {
    let { hidden } = this.state;
    hidden = !hidden;
    this.setState({hidden});
  }

  render() {
    let { dropDownItems } = this.props;
    let { hidden } = this.state;

    if(!dropDownItems) return null;

    return (
      <div className={container}>
        <p className={dropDownButton} 
          onClick={this.toggleDropDown}>{hidden ? '╲╱' : '╱╲'}</p>
        <div hidden={hidden}>
          {dropDownItems && dropDownItems.map((item, idx) => <p key={idx}>{item}</p>)}
        </div>
      </div>
    );
  }
}

export default DropDown;